import { render, staticRenderFns } from "./StudentScript.vue?vue&type=template&id=20b7b2dc&scoped=true"
import script from "./StudentScript.vue?vue&type=script&lang=js"
export * from "./StudentScript.vue?vue&type=script&lang=js"
import style0 from "./StudentScript.vue?vue&type=style&index=0&id=20b7b2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7b2dc",
  null
  
)

export default component.exports